import { types } from './actions';

const initialState = {
  isLoading: true,
  isWorkflowLoading: true,
  page: 1,
  pageSize: 10,
  quotes: [],
  quoteWorkflow: null,
  totalCount: 0,
  filters: {},
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case types.WORKFLOWS_INIT:
      return {
        ...initialState,
      };
    case types.FETCH_QUOTE_WORKFLOW_REQUEST:
      return {
        ...state,
        isWorkflowLoading: true,
      };
    case types.FETCH_QUOTE_WORKFLOW_SUCCESS:
      return {
        ...state,
        isWorkflowLoading: false,
        quoteWorkflow: payload.quoteWorkflow,
      };
    case types.FETCH_QUOTES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_QUOTES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        quotes: payload.quotes,
        totalCount: payload.totalCount,
      };
    case types.FETCH_QUOTES_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.WORKFLOWS_PAGINATE:
      return {
        ...state,
        isLoading: true,
        page: payload.pageNumber,
      };
    case types.WORKFLOWS_UPDATE:
      return {
        ...state,
        isLoading: true,
        page: payload.page,
        filters: payload.filters,
      };
    case types.WORKFLOWS_FILTER:
      return {
        ...state,
        isLoading: true,
        filters: payload.filters,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.dashboard.workflows;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsWorkflowLoading = (state) =>
  getScope(state).isWorkflowLoading;

export const getPage = (state) => getScope(state).page;

export const getPageSize = (state) => getScope(state).pageSize;

export const getFilters = (state) => getScope(state).filters;

export const getQuotes = (state) => getScope(state).quotes;

export const getQuoteWorkflow = (state) => getScope(state).quoteWorkflow;

export const getTotalCount = (state) => getScope(state).totalCount;
